import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Text, VStack } from 'ui_2';
import { Route as IndexRoute } from './index';
import Header from '@src/components/layout/Header';
import { useReferralQuest } from '@src/hooks/useQuests';
import { ReferralStats } from '@src/components/referral/ReferralRewards';
import { ReferralCode } from '@src/components/referral/ReferralCode';
import { useDappState } from '@src/hooks/useDappState';
import { Page } from '@src/components/layout/Page';
import { useEffectiveAccount } from '@src/hooks/useEffectiveAccount';

export const Route = createFileRoute('/referral')({
  staticData: {
    title: 'Referral',
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { data: questData } = useReferralQuest();
  const { isPuzzleWalletWebview } = useDappState();
  const { hasAuth } = useEffectiveAccount();

  return (
    <Page>
      <Header
        backRoute={IndexRoute.to}
        title='Referrals'
        viewTransition={isPuzzleWalletWebview}
      />
      {!hasAuth ? (
        <VStack className='w-full items-center justify-center gap-4 py-12'>
          <Text font='sm' color='gray-500'>
            Open this page in Puzzle Wallet to manage referrals
          </Text>
        </VStack>
      ) : (
        <>
          <ReferralStats />
          <VStack className='w-full max-w-[500px] justify-center gap-2'>
            <Text font='bold-md'>Refer and earn</Text>
            <VStack className='gap-[2px]'>
              {questData?.instructions?.map((text, ix) => (
                <Text font={ix === 0 ? 'sm' : 'xs'} key={ix}>
                  {text}
                </Text>
              ))}
            </VStack>
            <ReferralCode instructions={questData?.instructions} />
          </VStack>
        </>
      )}
    </Page>
  );
}
